/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountProviderTypeEnum } from './accountProviderTypeEnum';
import { Issues } from './issues';


export interface AccountsOnboardIssues { 
    /**
     * Account ID
     */
    account_id: string;
    issues: Issues;
    provider: AccountProviderTypeEnum;
}
export namespace AccountsOnboardIssues {
}


